import { isType } from '@ricoh/ria.client.core/utils/data/object';

import type { Page, PageOffline, PageOriginal } from '~/common/model/api/batch';

/**
 * Get original page id.
 *
 * @param {Page} page Page.
 *
 * @returns {string} Original page id.
 */
export function getOriginalPageId(page: Page): string {
  if (isType<PageOriginal>(page, 'original') || isType<PageOffline>(page, 'offline')) {
    return page.id;
  }

  return getOriginalPageId(page.duplicateFrom);
}

/**
 * Get page image URL.
 *
 * @param {Page} page Page.
 *
 * @returns {string} Image URL.
 */
export function getImageUrl(page: Page): string {
  if (isType<PageOriginal>(page, 'original') || isType<PageOffline>(page, 'offline')) {
    return page.imageUrl;
  }

  return getImageUrl(page.duplicateFrom);
}
